import React, { useCallback, useState, useEffect } from 'react';
import { showToast } from "./ToastManager";
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Carousel } from 'primereact/carousel';
import { Timeline } from 'primereact/timeline';

import Utils from "../utilities/Utils";

import AgendamentoService from '../service/AgendamentoService';
import FinanceiroService from '../service/FinanceiroService';
import RoleService from '../service/RoleService';
import AuthorizationService from '../service/AuthorizationService';

const agendamentoService = new AgendamentoService();
const financeiroService = new FinanceiroService();

const Dashboard = () => {

    const [loading1, setLoading1] = useState(false);
    const [agendamentos, setAgendamento] = useState([]);
    const [agendamentosTotal, setAgendamentosTotal] = useState(0);

    // Estados para valores PAGOS (status CAPTURED)
    const [valorPagoTotal, setValorPagoTotal] = useState(0);
    const [valorStarTotal, setValorStarTotal] = useState(0);
    const [valorPrestadorTotal, setValorPrestadorTotal] = useState(0);

    // Estados para valores PENDENTES (status diferente de CAPTURED)
    const [valorPagoPendente, setValorPagoPendente] = useState(0);
    const [valorStarPendente, setValorStarPendente] = useState(0);
    const [valorPrestadorPendente, setValorPrestadorPendente] = useState(0);
    const [pagamentosPendentesCount, setPagamentosPendentesCount] = useState(0);

    // Estados para métricas de gestão
    const [taxaConclusao, setTaxaConclusao] = useState(0);
    const [ticketMedio, setTicketMedio] = useState(0);

    // NOVOS ESTADOS: Valores por forma de pagamento
    const [valorPagoPix, setValorPagoPix] = useState(0);
    const [valorPagoCard, setValorPagoCard] = useState(0);

    // NOVO STATE: Controlar range de dias selecionado
    const [rangeDias, setRangeDias] = useState(30);

    const iss = localStorage.getItem('iss');

    // NOVO: Helper para formatar período (ex: "Fev-26")
    const formatMonthYear = (date) => {
        const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        const mes = meses[date.getMonth()];
        const ano = date.getFullYear().toString().slice(-2);
        return `${mes}-${ano}`;
    };

    // REFATORADO: Calcula data inicial e final baseado em dias
    const getDatasParaFiltro = (dias) => {
        const hoje = new Date();
        let dataInicial, dataFinal;

        if (dias === 30) {
            // Mês atual: dia 01 do mês até hoje
            dataInicial = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            dataFinal = hoje;
        } else if (dias === 60) {
            // Mês anterior completo (01 até último dia)
            const mesPrevio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
            dataInicial = new Date(mesPrevio.getFullYear(), mesPrevio.getMonth(), 1);
            dataFinal = new Date(mesPrevio.getFullYear(), mesPrevio.getMonth() + 1, 0);
        } else if (dias === 90) {
            // Dois meses atrás completo (01 até último dia)
            const doisMesesAtras = new Date(hoje.getFullYear(), hoje.getMonth() - 2, 1);
            dataInicial = new Date(doisMesesAtras.getFullYear(), doisMesesAtras.getMonth(), 1);
            dataFinal = new Date(doisMesesAtras.getFullYear(), doisMesesAtras.getMonth() + 1, 0);
        }

        const dataFinalFormatada = Utils.formatDataAddRemoveDays(
            dataFinal.toISOString().split('T')[0],
            0,
            "+"
        ) + "T23:59:59";

        const dataInicialFormatada = Utils.formatDataAddRemoveDays(
            dataInicial.toISOString().split('T')[0],
            0,
            "+"
        ) + "T00:00:00";

        return { dataInicial: dataInicialFormatada, dataFinal: dataFinalFormatada };
    };

    // NOVO: Helper para obter label do botão dinamicamente
    const getLabelBotao = (dias) => {
        if (dias === 30) return '30 dias (Mês)';

        const hoje = new Date();
        let dataReferencia;

        if (dias === 60) {
            dataReferencia = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        } else if (dias === 90) {
            dataReferencia = new Date(hoje.getFullYear(), hoje.getMonth() - 2, 1);
        }

        return formatMonthYear(dataReferencia);
    };

    /* const initAgendamento = useCallback(async (dias = rangeDias) => {
        const { dataInicial, dataFinal } = getDatasParaFiltro(dias);

        setLoading1(true);

        try {
            const data = await agendamentoService.listAllAgendamentos(iss, dataInicial, dataFinal);
            setAgendamentosTotal(data.data.length);
        } catch (error) {
            console.error("Erro ao carregar agendamentos:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar agendamentos' });
        } finally {
            setLoading1(false);
        }
    }, [iss, rangeDias]); */

    const initPagamentos = useCallback(async (dias = rangeDias) => {
        const { dataInicial, dataFinal } = getDatasParaFiltro(dias);

        setLoading1(true);

        try {
            const data = await financeiroService.listAllPagamentos(iss, dataInicial, dataFinal);
            // setAgendamentosTotal(data.data.count);

            // Separar pagamentos CAPTURADOS de PENDENTES
            const pagamentosCapturados = data.data.rows.filter(e =>
                e.ipag_payments?.status?.toUpperCase() === 'CAPTURED'
            );

            const pagamentosPendentes = data.data.rows.filter(e =>
                e.ipag_payments?.status?.toUpperCase() !== 'CAPTURED'
            );

            // Calcular totais de pagamentos CAPTURADOS (efetivamente pagos)
            let totalValorPago = 0.0;
            let totalValorStar = 0.0;
            let totalValorPrestador = 0.0;

            pagamentosCapturados.forEach(e => {
                totalValorPago += e.valor_pago || 0;
                totalValorStar += e.valor_star || 0;
                totalValorPrestador += e.valor_prestador || 0;
            });

            // Calcular totais de pagamentos PENDENTES
            let totalValorPagoPendente = 0.0;
            let totalValorStarPendente = 0.0;
            let totalValorPrestadorPendente = 0.0;

            pagamentosPendentes.forEach(e => {
                totalValorPagoPendente += e.valor_pago || 0;
                totalValorStarPendente += e.valor_star || 0;
                totalValorPrestadorPendente += e.valor_prestador || 0;
            });

            // NOVO: Calcular valores por forma de pagamento (apenas CAPTURADOS)
            const totalPix = pagamentosCapturados
                .filter(p => p.forma_pagamento?.toLowerCase() === 'pix')
                .reduce((sum, p) => sum + (p.valor_pago || 0), 0);

            const totalCard = pagamentosCapturados
                .filter(p => p.forma_pagamento?.toLowerCase() === 'card')
                .reduce((sum, p) => sum + (p.valor_pago || 0), 0);

            // Calcular métricas de gestão
            const totalPagamentos = data.data.rows.length;
            const taxa = totalPagamentos > 0
                ? (pagamentosCapturados.length / totalPagamentos) * 100
                : 0;

            const ticket = pagamentosCapturados.length > 0
                ? totalValorPago / pagamentosCapturados.length
                : 0;

            // Atualizar estados - Valores PAGOS
            setValorPagoTotal(totalValorPago);
            setValorStarTotal(totalValorStar);
            setValorPrestadorTotal(totalValorPrestador);

            // Atualizar estados - Valores PENDENTES
            setValorPagoPendente(totalValorPagoPendente);
            setValorStarPendente(totalValorStarPendente);
            setValorPrestadorPendente(totalValorPrestadorPendente);
            setPagamentosPendentesCount(pagamentosPendentes.length);

            // Atualizar estados - Métricas
            setTaxaConclusao(taxa);
            setTicketMedio(ticket);

            // NOVO: Atualizar estados - Valores por forma de pagamento
            setValorPagoPix(totalPix);
            setValorPagoCard(totalCard);

        } catch (error) {
            console.error("Erro ao carregar pagamentos:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar pagamentos' });
        } finally {
            setLoading1(false);
        }
    }, [iss, rangeDias]);

    // NOVO: Handler para mudança de filtro
    const handleFiltroChange = (dias) => {
        setRangeDias(dias);
        // initAgendamento(dias);
        initPagamentos(dias);
    };

    useEffect(() => {
        // initAgendamento(rangeDias);
        initPagamentos(rangeDias)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="layout-dashboard">
            {/* NOVO: Botões de filtro por período */}
            <div className="mb-4" style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
                <Button
                    label={getLabelBotao(30)}
                    onClick={() => handleFiltroChange(30)}
                    severity={rangeDias === 30 ? "info" : "secondary"}
                    outlined={rangeDias !== 30}
                    className="p-button-sm"
                />
                <Button
                    label={getLabelBotao(60)}
                    onClick={() => handleFiltroChange(60)}
                    severity={rangeDias === 60 ? "info" : "secondary"}
                    outlined={rangeDias !== 60}
                    className="p-button-sm"
                />
                <Button
                    label={getLabelBotao(90)}
                    onClick={() => handleFiltroChange(90)}
                    severity={rangeDias === 90 ? "info" : "secondary"}
                    outlined={rangeDias !== 90}
                    className="p-button-sm"
                />
            </div>

            <div className="grid">
                {/* Card: Agendamentos */}
                {/* <div className="col-12 md:col-6 lg:col-3">
                    <div className="card widget-overview-box widget-overview-box-1">
                        <span className="overview-title">
                            Agendamentos
                        </span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-text">
                                    {agendamentosTotal} <span className="overview-title">
                                        período selecionado
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Card: Valores Pagos (CAPTURADOS) */}
                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin()) && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-1">
                            <span className="overview-title">
                                Valores Pagos
                                <Badge value={taxaConclusao.toFixed(0) + '%'} severity="success" className="ml-2"></Badge>
                            </span>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorPagoTotal)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                no período selecionado
                            </span>
                        </div>
                    </div>
                )}

                {/* Card: Pagamentos Pendentes */}
                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin()) && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-2">
                            <span className="overview-title">
                                Pagamentos Pendentes
                                <Badge value={pagamentosPendentesCount} severity="warning" className="ml-2"></Badge>
                            </span>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorPagoPendente)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                no período selecionado
                            </span>
                        </div>
                    </div>
                )}

                {/* Card: Ticket Médio */}
                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin()) && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-3">
                            <span className="overview-title">
                                Ticket Médio
                            </span>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(ticketMedio)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                por transação
                            </span>
                        </div>
                    </div>
                )}

                {/* NOVO Card: Pagamentos via PIX */}
                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin()) && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-1">
                            <div className="flex align-items-center mb-2">
                                <i className="pi pi-qrcode text-2xl mr-2" style={{ color: '#00B4D8' }}></i>
                                <span className="overview-title">
                                    Pagamentos via PIX
                                </span>
                            </div>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorPagoPix)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                no período selecionado
                            </span>
                        </div>
                    </div>
                )}

                {/* NOVO Card: Pagamentos via Cartão */}
                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin()) && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-1">
                            <div className="flex align-items-center mb-2">
                                <i className="pi pi-credit-card text-2xl mr-2" style={{ color: '#FF6B6B' }}></i>
                                <span className="overview-title">
                                    Pagamentos via Cartão
                                </span>
                            </div>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorPagoCard)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                no período selecionado
                            </span>
                        </div>
                    </div>
                )}

                {/* Card: Taxas Recebidas (STAR) */}
                {RoleService.isAdmin() && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-1">
                            <span className="overview-title">
                                Taxas Recebidas
                            </span>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorStarTotal)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                no período selecionado
                            </span>
                        </div>
                    </div>
                )}

                {/* Card: Taxas Pendentes (STAR) */}
                {RoleService.isAdmin() && valorStarPendente > 0 && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-2">
                            <span className="overview-title">
                                Taxas Pendentes
                            </span>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorStarPendente)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                aguardando captura
                            </span>
                        </div>
                    </div>
                )}

                {/* Card: Valores Prestadores */}
                <div className="col-12 md:col-6 lg:col-3">
                    <div className="card widget-overview-box widget-overview-box-1">
                        <span className="overview-title">
                            {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin())
                                ? "Valores Pagos aos Prestadores"
                                : "Valores Recebidos"}
                        </span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-text">
                                    {Utils.formatCurrency(valorPrestadorTotal)}
                                </div>
                            </div>
                        </div>
                        <span className="overview-title">
                            no período selecionado
                        </span>
                    </div>
                </div>

                {/* Card: Valores Pendentes Prestadores */}
                {valorPrestadorPendente > 0 && (
                    <div className="col-12 md:col-6 lg:col-3">
                        <div className="card widget-overview-box widget-overview-box-2">
                            <span className="overview-title">
                                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin())
                                    ? "Valores Pendentes Prestadores"
                                    : "Valores Pendentes"}
                            </span>
                            <div className="flex justify-content-between">
                                <div className="overview-detail flex justify-content-between">
                                    <div className="overview-text">
                                        {Utils.formatCurrency(valorPrestadorPendente)}
                                    </div>
                                </div>
                            </div>
                            <span className="overview-title">
                                aguardando pagamento
                            </span>
                        </div>
                    </div>
                )}

                {/* Card: Taxa de Conclusão */}
                {(AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin()) && (
                    <div className="col-12 md:col-6 lg:col-4">
                        <div className="card">
                            <span className="overview-title mt-3 mb-3">
                                Taxa de Conclusão de Pagamentos
                            </span>
                            <ProgressBar
                                value={taxaConclusao}
                                showValue={true}
                                className="mb-2"
                                style={{ height: '18px' }}
                                pt={{
                                    label: { style: { color: '#ffffff', fontWeight: '600', fontSize: '14px' } }
                                }}
                            />
                            <small className="text-500">
                                {pagamentosPendentesCount > 0
                                    ? `${pagamentosPendentesCount} pagamento(s) aguardando confirmação`
                                    : 'Todos os pagamentos foram confirmados'}
                            </small>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Dashboard, comparisonFn);